import axios from 'axios'

const setAuthToken = (token) => {
  if (token) {
    // Apply token to every request
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

    // Also set session token if it exists
    const sessionToken = sessionStorage.getItem('sessionToken')
    if (sessionToken) {
      axios.defaults.headers.common['x-session-token'] = sessionToken
    }
  } else {
    // Delete auth headers
    delete axios.defaults.headers.common['Authorization']
    delete axios.defaults.headers.common['x-session-token']
  }
}

export default setAuthToken
